import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Home Improvement Projects' },
	{
		name: 'description',
		content: 'Home Improvement Projects',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">Home Improvement Projects</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Maintaining your property often entails both minor and major home
				improvement projects. If you have plans to have your home updated or
				renovated, here are some tips for you. Are you the contractor doing the
				work? We've got some pointers for you as well.
			</p>
			<h3>For Homeowners</h3>
			<ul>
				<li>
					Make sure you have a clear plan for what you intend to accomplish with
					your project.
				</li>
				<li>Obtain any necessary permits before you start the work.</li>
				<li>Choose a contractor with a good reputation.</li>
				<li>
					Make sure your contractor has liability insurance. You should request
					a certificate of insurance proving that coverage is in place.
				</li>
				<li>
					If the changes you make add to the value of your home, make sure your
					homeowner's policy gets updated to reflect the increase.
				</li>
				<li>
					If you make changes to the roof or to the heating, electrical, or
					plumbing system, make sure you are getting the right discounts for
					doing the updates.
				</li>
			</ul>
			<h3>For Contractors</h3>
			<ul>
				<li>
					Make sure you have the right liability coverage for the job you are
					doing.
				</li>
				<li>
					If you have employees or workers, make sure you carry the required
					worker's compensation insurance.
				</li>
				<li>
					If you subcontract any work to other contractors, be certain to have a
					written, executed contract with them. It should require that each
					subcontractor name you as additional insured and carry limits not
					lower than your own. It should also include a provision that the
					subcontractor agrees to hold you harmless. You should obtain a
					certificate of insurance from them at least annually.
				</li>
				<li>
					Check your policy to make sure that your tools and equipment have the
					right amount of coverage.
				</li>
				<li>
					Keep complete records of each job you do, the type of work, the amount
					that you collect, and the payroll for yourself and your employees.
					When it comes time to complete the annual audit, you will be glad that
					you kept accurate records.
				</li>
			</ul>
		</>
	)
}
